import { useSnackbar } from 'notistack';
import { ApiServiceErr, getApiError } from '../api-http/apiService';
import { ERROR, SUCCESS } from './constant';

export const useSnack = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSuccessSnack = (msg: string) =>
    enqueueSnackbar(msg, {
      variant: SUCCESS,
    });

  const showErrSnack = (err: ApiServiceErr | string) =>
    enqueueSnackbar(getApiError(err), { variant: ERROR });

  return { showSuccessSnack, showErrSnack };
};
